export default __webpack_public_path__ + "static/Image014-eba6c95405cdef2fc0f45f89230f0356.png";